export const data = [
  {
    id: 1,
    title: "React Hooks",
    details: [
      "Introduced in React 16.8",
      "Can be used to manage state",
      "Easy and Reusable",
      "No method bindings",
      "Easy to manage comp lifecycle",
      "Rule: Only inside functional comp",
      "Rule: Must run in an order",
      "Rule: Can not be used in condtions",
      "Rule: On top level of the function",
    ],
  },
  {
    id: 2,
    title: "State Vs Props",
    details: [
      "State: Managed with in comp",
      "State: Can be changed",
      "Props: Get passed to the comp",
      "Props: Immutable",
    ],
  },
  {
    id: 3,
    title: "Pure Functions",
    details:
      "Pure functions are functions that accept an input and returns a value without modifying any data outside its scope(Side Effects) and are deterministic. Ex: Reducers are just pure functions that take the previous state and an action, and return the next state.",
    code: [
      "Same Input always returns Same Output:",
      "const add = (x, y) => x + y;",
      "add(2, 3); // 5",
    ],
  },
  {
    id: 4,
    title: "Reducers are Pure?",
    details:
      "Reducer takes the previous state and an action, and return the next state. Internally, Redux compares the reference of the prev state and the current state object, if we mutate the object then the reference of the object won't be changed. It means comparision always results to be true and state updation is not happend from redux",
    code: [
      "export default function appReducer(state = initialState, action) {\n" +
        "  switch (action.type) {\n" +
        "    case 'todos/todoAdded': {\n" +
        "      return {\n" +
        "        ...state,\n" +
        "        todos: [\n" +
        "          ...state.todos,\n" +
        "          {\n" +
        "            id: nextTodoId(state.todos),\n" +
        "            text: action.payload,\n" +
        "            completed: false\n" +
        "          }\n" +
        "        ]\n" +
        "      }\n" +
        "    }\n" +
        "    \n" +
        "    default:\n" +
        "      return state\n" +
        "  }\n" +
        "}\n",
    ],
  },
  {
    id: 5,
    title: "Pure Components",
    details:
      "Pure Components in react are the components which do not re-renders when the value of state and props has been updated with the same values. Pure Components restricts the re-rendering ensuring the higher performance of the Component",
  },
  {
    id: 6,
    title: "Reducer <-> Actions",
    details:
      "There is no relation between redcuer and action, many reducers can react to a single actions, a single reducer can react to multiple actions.",
  },
  {
    id: 7,
    title: "JS Closures",
    details:
      "A function along with reference to its outer environment form a Closure. ie., An inner function can have access to the outer functions variables. Closures can help providing data hiding and encapsulation. one drawback is memory allocation is not freed until whole context execution.",
    code: [
      "const numberGenerator = () => {\n" +
        "  var num = 1;\n" +
        "  function showNumber() { \n" +
        "    console.log(num);\n" +
        "  }\n" +
        "  num++;\n" +
        "  return showNumber;\n" +
        "}\n" +
        "\n" +
        "var number = numberGenerator();\n" +
        "number(); // 2\n" +
        "\n" +
        "// num variable can be accessed by showNumber\n" +
        "// bcz of JS Closures",
    ],
  },
  {
    id: 8,
    title: "Hoisting",
    details:
      "Whenever a javascript program is executed, the JS engine creates  an execution context. It has two phases MEMORY CREATION PHASE and EXECUTION PHASE. In memory allocation phase, declared variables allocated with `undefined` and functions with its reference (copy). Thats why we can execute functions before its declaration",
  },
  {
    id: 9,
    title: "let - const - var",
    details: [
      "Let - having BLOCK scope",
      "Let - Can be reassigned",
      "Const - having BLOCK scope",
      "Const - Cannot be re-assigned",
      "Const - Must be initialzed",
      "Var - having Functional Scope",
    ],
  },
  {
    id: 10,
    title: "Named vs Default Exports",
    details:
      "Named::: we can have multiple named exports per file and The name of imported module has to be the same as the name of the exported module. Default::: We can have only one default export per file. When we import we have to specify a name and The naming of import is completely independent in default export and we can use any name we like",
    code: [
      "Named:",
      " import {MODULE_NAME} from 'MODULE'",
      "Default:",
      " import MODULE_NAME from 'MODULE'",
    ],
  },
  {
    id: 11,
    title: "Polyfill",
    details:
      "Babel transforms our code, written with new features, into any browser that can understand but it cannot transform some features like fetch(), includes(). i.e. Some features can be compiled and some features can be Polyfilled. Polyfill is code that implements a feature on web browsers that do not support the feature. ex: log() is not a browser functionality but we can implement it like `window.log = msg => console.log(msg)`.",
  },
  {
    id: 12,
    title: "Error Boundaries",
    details:
      "Error boundaries are React components that catch JS errors anywhere in their child component tree, logs those erros and display a fallback UI. Two lifecycle methods need to implement in Error boundary 1) static getDerivedStateFromProps() - used to render fallback UI 2) componentDidCatch() - used to log information",
    code: [
      "cclass ErrorBoundary extends React.Component {\n" +
        "  constructor(props) {\n" +
        "    super(props);\n" +
        "    this.state = { hasError: false };\n" +
        "  }\n" +
        "\n" +
        "  static getDerivedStateFromError(error) {\n" +
        "    // Update state so the next render will show the fallback UI.\n" +
        "    return { hasError: true };\n" +
        "  }\n" +
        "\n" +
        "  componentDidCatch(error, errorInfo) {\n" +
        "    // You can also log the error to an error reporting service\n" +
        "    logErrorToMyService(error, errorInfo);\n" +
        "  }\n" +
        "\n" +
        "  render() {\n" +
        "    if (this.state.hasError) {\n" +
        "      // You can render any custom fallback UI\n" +
        "      return <h1>Something went wrong.</h1>;\n" +
        "    }\n" +
        "\n" +
        "    return this.props.children; \n" +
        "  }\n" +
        "}",
    ],
  },
  {
    id: 13,
    title: "React Middleware",
    details:
      "Reducers are pure functions - No side effects. In general, Action creators return plain javascript object to the pure reducers, based on the type action state updated. But some times action payload has to be fetched from an API. So, a middleware is needed to perform those async tasks. It is hooked up between Action and Reducer and provide an abilty to the action creators to perform Async tasks like fetch data.",
    code: [
      "import { createStore, combineReducers, applyMiddleware } from 'redux'\n" +
        "import firstReducer from './reducer/firstReducer'\n" +
        "import someMiddleware from './middleware/some'\n" +
        " \n" +
        "// combine reducers\n" +
        "const rootReducer = combineReducers(moviesReducer, /* add more reducers here */)\n" +
        " \n" +
        "// create a redux store from reducers and middleware\n" +
        "const store = createStore(\n" +
        "  rootReducer,\n" +
        "  applyMiddleware(apiMiddleware, /* add other middlewares here*/)\n" +
        ")\n",
    ],
  },
  {
    id: 14,
    title: "Higher order Functions",
    details:
      "In JS, functions as first-class citizens and are a special type of objects. We can assign function to a variable, pass as a parameter. Higher-Order function is a function that receives a function as an argument or returns the function as output. Ex: map(), filter() etc",
    code: [
      "const double = n => n * 2\n\n[1, 2, 3, 4].map(double) // [ 2, 4, 6, 8 ]\n",
    ],
  },
  {
    id: 15,
    title: "Higher order Component",
    details:
      "Similar to Higher order functions, Higher-order component is a function that takes a component and returns a new component. HOC is a pure function with zero side-effects. HOC is a design patten which keeps our code DRY. Ex: IronMan = withSuit(Tony)",
  },
  {
    id: 16,
    title: "Render Props",
    details:
      "Technique for sharing code between react components usina a prop whose value is function. i.e, A wrapper comp is having common code which is required for multiple other components. Now, other components can access that common code by going into that wrapper comp as a prop (render) and access the code required return a final JSX.",
  },
  {
    id: 17,
    title: "HOC vs Render Props",
    details:
      "Both HOC and Render props are great patterns, render props is much easier to setup - No naming collision issues for props. - No static method hoisting - Less boiler plate code and more predictable Than HOC.",
  },
  {
    id: 18,
    title: "Currying",
    details:
      "Currying is a transformation of functions that translates a function from callable as f(a, b, c) into callable as f(a)(b)(c). Main advantage of currying: We can easily generate partial functions",
    code: [
      "function curry(f) { \n" +
        "  return function(a) {\n" +
        "    return function(b) {\n" +
        "      return function(c){\n" +
        "        return f(a, b, c)\n" +
        "      }\n" +
        "    };\n" +
        "  };\n" +
        "}\n" +
        "\n" +
        "const sum = (a, b, c) => a + b + c\n" +
        "\n" +
        "let curriedSum = curry(sum);\n" +
        "\n" +
        "let addFirstValue = curriedSum(1)\n" +
        "let addSecondValue = addFirstValue(4)\n" +
        "let addThirdValue = addSecondValue(9) // 14",
    ],
  },
  {
    id: 19,
    title: "Optimize Performance",
    details: [
      "React.memo()",
      "React Profiler",
      "useMemo()",
      "useCallback()",
      "Disciplined props drilling",
      "Check Reference equality",
      "Unique key in iterations"
    ],
    code: [
        "React Memo sample:\n" +
      "export function Movie({ title, releaseDate }) {\n" +
        "  return (\n" +
        "    <div>\n" +
        "      <div>Movie title: {title}</div>\n" +
        "      <div>Release date: {releaseDate}</div>\n" +
        "    </div>\n" +
        "  );\n" +
        "}\n" +
        "\n" +
        "export const MemoizedMovie = React.memo(Movie);",
    ],
  },
  {
    id: 20,
    subject: 'JS',
    title: "Axios",
    details: "Axios is a HTTP client based on the XMLHttpRequests. Similar to the Fetch API and is to perform HTTP requests. Key features of Axios is the ability to intercept HTTP request and response. i.e, We can execute any functionality, Before making the request like Adding HTTP Headers etc., or After server's response like logging errors. Its like a common code for each req or resp",
    code: [
      "const axios = require('axios');\n" +
        '\n' +
        'axios.interceptors.request.use(req => {\n' +
        '  console.log("req.url");\n' +
        '  // Important: request interceptors **must** return the request.\n' +
        '  return req;\n' +
        '});\n' +
        '\n' +
        '// Prints "get https://jsonplaceholder.typicode.com/users"\n' +
        "await axios.get('https://jsonplaceholder.typicode.com/users');\n" +
        '\n' +
        '// Prints "post https://jsonplaceholder.typicode.com/posts"\n' +
        "await axios.post('https://jsonplaceholder.typicode.com/posts', {});"
    ],
  },
  {
    id: 21,
    subject: 'React',
    title: "PropTypes",
    details: "In react Props are coming from parent component and we are not sure whether we are getting expected type of props or not ex: we might expect string prop but ends up as number type. This might break the application. It can be possible to find lot of bugs with typechecking.",
    code: [
      "import PropTypes from 'prop-types';\n" +
        '\n' +
        'class Greeting extends React.Component {\n' +
        '  render() {\n' +
        '    return (\n' +
        '      <h1>Hello, {this.props.name}</h1>\n' +
        '    );\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        'Greeting.propTypes = {\n' +
        '  name: PropTypes.string\n' +
        '};'
    ],
  },
  {
    id: 22,
    subject: 'React',
    title: "StrictMode",
    details: ["StrictMode component highlights potential problems in the app, throws Warnings And is only for Dev"," Ex: Identifying unsafe lifecycles", "Ex: Detects unexpected side effects", "Ex: Deprecated method usages"],
    code: [
      "import PropTypes from 'prop-types';\n" +
        '\n' +
        'class Greeting extends React.Component {\n' +
        '  render() {\n' +
        '    return (\n' +
        '      <h1>Hello, {this.props.name}</h1>\n' +
        '    );\n' +
        '  }\n' +
        '}\n' +
        '\n' +
        'Greeting.propTypes = {\n' +
        '  name: PropTypes.string\n' +
        '};'
    ],
  }

];
